"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/TVFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_234)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_234`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V24H-6V0Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 12H12V0H30V24H-6V12Z",
					fill: "#00B2EE"
				}),
				/* @__PURE__ */ n("path", {
					d: "M7.81205 19.2361L8.98805 22.8601L5.90405 20.6201H9.72005L6.63605 22.8601L7.81205 19.2361ZM22.2561 13.6001L23.4321 17.2241L20.3481 14.9841H24.1601L21.0761 17.2241L22.2561 13.6001ZM26.5121 10.4601L27.6881 14.0841L24.6041 11.8441H28.4161L25.3321 14.0841L26.5121 10.4601ZM26.5121 1.49609L27.6881 5.12009L24.6041 2.88009H28.4161L25.3321 5.12009L26.5121 1.49609Z",
					fill: "#FFDA44"
				}),
				/* @__PURE__ */ n("path", {
					d: "M11.996 0V8.252H8.756L11.996 10.412V12H10.408L5.248 8.564V12H0.748V8.564L-4.412 12H-6V10.412L-2.76 8.252H-6V3.752H-2.76L-6 1.596V0H-4.412L0.748 3.436V0H5.248V3.436L10.408 0H11.996Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M4.124 0H1.872V4.88H-6V7.128H1.872V12H4.124V7.128H11.996V4.88H4.124V0Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M11.996 1.59595V3.75195H8.75598L11.996 1.59595Z",
					fill: "#2E52B2"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 11.9999V11.2279L-1.604 8.25191H-0.0159993L-5.488 11.9999H-6ZM-5.488 0.00390625L-0.0159993 3.75191H-1.604L-6 0.775906V0.00390625H-5.488ZM11.996 0.00790625V0.779906L7.6 3.75191H6.012L11.484 0.00790625H11.996ZM11.484 11.9999L6.012 8.25191H7.6L11.996 11.2279V11.9999H11.484Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M22.7961 5.26392L23.9721 8.88792L20.8881 6.64792H24.7001L21.6161 8.88792L22.7961 5.26392ZM17.3601 7.50792L18.5361 11.1319L15.4521 8.89192H19.2641L16.1801 11.1319L17.3601 7.50792ZM18.5601 17.2239L19.7361 20.8479L16.6521 18.6079H20.4641L17.3801 20.8479L18.5601 17.2239ZM13.5201 13.2799L14.6961 16.9039L11.6121 14.6639H15.4241L12.3401 16.9039L13.5201 13.2799ZM13.5201 18.5599L14.6961 22.1839L11.6121 19.9439H15.4241L12.3401 22.1839L13.5201 18.5599Z",
					fill: "#FFDA44"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_234`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as TVFlag };
